module.exports = __webpack_public_path__ + "static/karolina-e63c162c6d2da16c243aa22c90f8df5c.webp";